import * as SecureStore from 'expo-secure-store';

export async function setItem(key: string, value: string) {
  try {
    if (typeof SecureStore.setItemAsync === 'function') {
      return await SecureStore.setItemAsync(key, value);
    }
  } catch (e) {
    // fallthrough to localStorage
  }
  if (typeof window !== 'undefined' && window.localStorage) {
    window.localStorage.setItem(key, value);
    return;
  }
  throw new Error('No storage backend available');
}

export async function getItem(key: string): Promise<string | null> {
  try {
    if (typeof SecureStore.getItemAsync === 'function') {
      return await SecureStore.getItemAsync(key);
    }
  } catch (e) {
    // fallthrough to localStorage
  }
  if (typeof window !== 'undefined' && window.localStorage) {
    return window.localStorage.getItem(key);
  }
  return null;
}

export async function deleteItem(key: string) {
  try {
    if (typeof SecureStore.deleteItemAsync === 'function') {
      return await SecureStore.deleteItemAsync(key);
    }
  } catch (e) {
    // fallthrough to localStorage
  }
  if (typeof window !== 'undefined' && window.localStorage) {
    window.localStorage.removeItem(key);
    return;
  }
}
